import React from 'react';

import { permissions } from '@vlabs/shared/config';
import { useModal } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import type { ButtonWithPermissionsProps } from '@vlabs/monokit/shared/ui/button-with-permissions';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';

import { ExportTaskStepper } from './ExportTaskStepper';
import type { TFilters, TObjectType } from '../types';

interface ExportTaskButtonProps extends Omit<ButtonWithPermissionsProps, 'permissions' | 'onClick'> {
  objectType: TObjectType;
  filters?: TFilters;
  onExportTask?: VoidFunction;
}

export function ExportTaskButton({
  objectType,
  filters = {},
  onExportTask = undefined,
  ...props
}: ExportTaskButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const modal = useModal();

  return (
    <React.Fragment>
      {modal.wrap(<ExportTaskStepper
        filters={filters}
        objectType={objectType}
        onSubmit={() => {
          onExportTask?.();
          modal.close();
        }}
      />)}

      <ButtonWithPermissions
        data-testid={`${objectType}ExportButton`}
        onClick={modal.open}
        permissions={{ rules: [permissions.task.creation] }}
        {...props}
      >
        {props?.children ?? t('features:exportTask.titles.export', { context: objectType })}
      </ButtonWithPermissions>
    </React.Fragment>
  );
}
